export default {
  dataIterator: {
    rowsPerPageText: 'Stéck pro Säit:',
    rowsPerPageAll: 'All',
    pageText: '{0}-{1} vun {2}',
    noResultsText: 'Keen Resultat',
    nextPage: 'Nächst Säit',
    prevPage: 'Säit virdrun'
  },
  dataTable: {
    rowsPerPageText: 'Zeilen pro Säit:'
  },
  noDataText: 'Kéng disponibel Donnée'
}
